<template>
    <div class="page-tabs-box">
        <el-tabs v-model="activeName" @tab-click="clickEvent">
            <el-tab-pane label="入场数据" name="1" link="/activityManage/daping/list"></el-tab-pane>
            <el-tab-pane v-if="$utils.have('/group/configInfo')" label="销售数据" name="2" link="/activityManage/daping/salelist"></el-tab-pane>
			<el-tab-pane v-if="$utils.have('/daping/invite/list')" label="邀请函数据" name="3" link="/activityManage/daping/invitelist"></el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
export default {
    props:{
        name:{
            type: String,
            default: '1'
        }
    },
    data(){
        return{
            activeName: this.name
        }
    },
    methods:{
        clickEvent(tab){
            if (tab.$attrs.link) this.$router.push(tab.$attrs.link)
        }
    }
}
</script>